/** @ignore */
export const APP_VERSION = '##APP_VERSION##'
/** @ignore */
export const APP_GLOBAL = '##APP_GLOBAL##'

/**
 * Global Variable Name of IBSheet
 * @ignore
 */
export const IBSHEET_GLOBAL = 'IBSheet'

/**
 * Unique Name for IBSheet
 * @ignore
 */
export const IBSHEET = 'ibsheet'

/**
 * Auto Generate Sheet ID Prefix
 * @ignore
 */
export const IBSHEET_PREFIX = 'sheet_'

/**
 * Auto Generate Sheet Element ID Prefix
 * @ignore
 */
export const IBSHEET_EL_PREFIX = 'sheetouter_'
